

import { defineComponent, ref, watch, onMounted, Ref } from "vue";
import useEmitter from "@/composables/Emmiter";
import { useStore } from "vuex";
import FilterBase from "@/layout/header/partials/filters/FilterBase.vue";
import Api from "@/services/Api";
import { ElConfigProvider } from "element-plus";
import ptBr from "element-plus/lib/locale/lang/pt-br";

interface Lubrificante {
  nome: string;
  tipoProduto: string;
}

export default defineComponent({
  name: "FilterMarcas",
  components: {
    FilterBase,
    ElConfigProvider,
  },

  setup(props, { emit }) {
    const emitter = useEmitter();
    const closeModal = ref(false);
    const spanWarning = ref(false);

    const paramsFilter: Ref<Lubrificante> = ref({
      nome: "",
      tipoProduto: "",
    })

    async function enviarEmit() {
      await emitter.emit("paramsFilter", {
        paramsFilter: paramsFilter.value,
      });
      closeModal.value = !closeModal.value;
    }

    // watch(() => paramsFilter.value, () => {console.log('aqui', paramsFilter.value)}, {deep:true}) 

    return { spanWarning, enviarEmit, ElConfigProvider, ptBr, paramsFilter, closeModal };
  },
});
